export class ObservableHelper {
    static oneTimeSubscription(resolve, subject, resolveCondition) {
        const s = subject.subscribe({
            next(x) {
                if (!resolveCondition || resolveCondition(x)) {
                    resolve(x);
                    s.unsubscribe();
                }
            }
        });
    }
}
//# sourceMappingURL=ObservableHelper.js.map